import axios from "../axios";

/**
 * Store auto-login (magic link) APIs.
 *
 * Backend (to be implemented):
 * - POST /api/store/auto_login_links  (sales-only) -> { token }
 * - POST /api/store/auto_login        (public)     -> { token, user }
 */

const STORE_AUTH_BASE = "/store";

export async function createAutoLoginLink(body) {
  // body: { name, mobile, ttl_seconds? }
  return axios.post(`${STORE_AUTH_BASE}/auto_login_links`, body);
}

export async function consumeAutoLoginToken({ token, mobile }) {
  return axios.post(`${STORE_AUTH_BASE}/auto_login`, { token, mobile });
}

